import * as action from './actions/userprofile'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { router } from '@/router'

const Profile = RepositoryFactory.get('profile')
const userProfile = JSON.parse(localStorage.getItem('port_user_profile'))
const initialState = {
  id: 0,
  phone: '',
  inn: '',
  is_approve: 0,
  user_type: 4,
  profile: {
    user_organizations: [],
  },
  current: null,
  loading: true,
}

export default {
  namespaced: true,
  state: userProfile ? userProfile : { ...initialState },
  getters: {
    userInfo: state => state,
    getLoading: state => state.loading,
    getIdOrgs: state => ({
      id: state.id,
      orgs: state.profile.user_organizations,
      loading: state.loading,
    }),
    getByKey:
      state =>
      (key, subKey = false) => {
        if (!subKey) {
          return state[key]
        }

        return state[key] ? state[key][subKey] : {}
      },
  },
  actions: {
    [action.GET_PROFILE]: async ({ commit }, user_type) => {
      await Profile.getProfile().then(res => {
        const data = res.data
        const userType = data.user_type || user_type
        if (data) {
          commit(action.SET_PROFILE, { data, userType })
        }
      })
    },
    [action.CHANGE_PROFILE]: async ({ commit, dispatch }, data) => {
      localStorage.setItem('auth-token', data.token.token)
      commit(action.CLEAR_PROFILE)
      dispatch(action.GET_PROFILE, data.user_type)

      return router.push('/user')
    },
  },
  mutations: {
    [action.SET_PROFILE]: (state, { data, user_type }) => {
      const org = data.profile.user_organizations
      let cur = null

      if (state.current && org.length > 1) {
        cur = org.find(o => o.id === state.current.id) || null
      }
      data.current = org.length === 1 ? { ...org[0] } : cur

      if (user_type) {
        data.user_type = user_type
      }
      state.loading = false
      Object.assign(state, data)
      localStorage.setItem('port_user_profile', JSON.stringify(state))
    },
    [action.SET_CURRENT]: (state, index) => {
      state.current =
        index >= 0 ? { ...state.profile.user_organizations[index] } : null
      localStorage.setItem('port_user_profile', JSON.stringify(state))
    },
    [action.CLEAR_PROFILE]: state => {
      localStorage.removeItem('port_user_profile')
      Object.assign(state, initialState)
    },
  },
}
